// Validates VAN batch _ids with jjv directly. This used to wrap json-clay,
// whose last npm release pins lodash 3, minimist 1.2.0 and semver 5.0.3;
// jjv is what json-clay validated with and is already an api dependency.
const jjv = require('jjv')
const schema = require('./schema')

const validator = jjv()
validator.addSchema(schema.id, schema)

module.exports = {
  validate: json => validator.validate(schema, json),
  batchIdPattern: schema.properties._id.pattern
}
